export default __webpack_public_path__ + "5cba0df681a9732d8d5a6265742e3c14.png";